
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import AppLayout from '../../../../../layout/components/AppLayout';
import { useAppData } from '../../../../../context/AppDataContext';
import { useAlert } from '../../../../../context/AlertContext';
import projectTeamServices from '../projectTeamServices';
import { Cancel, EditRoad, Print } from '@mui/icons-material';
import companyServices from '../../finance/company/companyServices';
import { IconButton } from '@mui/material';


function ProjectTeamDetailsPage() {
    const {id} = useParams();

    const {getMasterLabel} = useAppData();
    const {AppAlert} = useAlert();
    const [teamList,setTeamList] = useState(null);

    const [editList,setEditList] = useState(false);

    const [companyList,setCompanyList] = useState(null);

    const getCompanyList = () =>{
        companyServices.getList().then(res=>{
            setCompanyList(res.data);
        }).catch(error=>{
            console.log(error)
        })
    }

    useEffect(()=>{
        getCompanyList();
    },[id])
    

    const [selectedCompany,setSelectedCompany] = useState(0)

    const getProjectTeam = () =>{
        console.log("getting ProjectTeam");
        projectTeamServices.getByProjectId(id).then(res=>{
            setTeamList(res.data)
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            console.log("finnaly")
        })
    }


   

    const remove = (index) =>{
        setTeamList(prevList => prevList.filter((_, i) => i !== index));
        
    }

    useEffect(()=>{
        getProjectTeam();
    },[id])


    const printComponentRef = useRef();

    const printList = () =>{
        setEditList(false);
        setTimeout(()=>{
            handlePrint();
        },50)
        
    }
    
    const handlePrint = useReactToPrint({
      content: () => printComponentRef.current,
      //pageStyle:"@page { size: 2.5in 2.5in; margin: 0; padding:0 }, @media print { @page {  size: 2.5in 2.5in margin: 0mm !important;  body,html{padding:0px;margin:0px;} } }",
      //pageStyle:"@media print { html, body { height: 2.5in; /* Use 100% here to support printing more than a single page*/ margin: 0 !important;padding: 0 !important;overflow: hidden;}}; @page { size: 2.5in 2.5in; margin: 0; }"
      //onAfterPrint:()=>{navigate("/kiosk/dashboard")}
    });

    return (
        companyList &&
        <AppLayout>
            <div className='container'>
                <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div class="form-floating mb-3">
                            <select className="form-control"
                                    onChange={(e)=> 
                                        setSelectedCompany(e.target.value)
                                    }
                                    value={selectedCompany}
                                >
                                {companyList?.map((company,i)=>
                                    <option value={i}>{company.companyName}</option>
                                )}
                            </select>
                            <label>Select Company</label>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <button className='btn btn-primary float-end' onClick={ printList}><Print/> Print</button>
                        <button className='btn btn-warning me-2 float-end' onClick={()=>setEditList(!editList)}>Edit List</button>
                    </div>
                    <div className='col-md-12'>
                        <hr/>
                    </div>
                </div>
                
                <div className='row p-4'  ref={printComponentRef}>
                    <div className='col-6'>
                        <h4 className='fw-bold'>{companyList[selectedCompany].companyName}</h4>
                        <div><span className='fw-bold'>GST No : </span>{companyList[selectedCompany].gst}</div>
                        <div style={{fontSize:12}}>Address : {companyList[selectedCompany].address},{companyList[selectedCompany].city}, {companyList[selectedCompany].state} {companyList[selectedCompany].pin}</div>
                    </div>
                    <div className='col-6'>
                        <div className='float-end'>
                            <img style={{maxWidth:"2in", height:"auto"}} src={companyList[selectedCompany].logo}/>
                            <div style={{fontSize:12}}>Phone : {companyList[selectedCompany].phone}</div>
                            <div style={{fontSize:12}}>Email : {companyList[selectedCompany].email}</div>
                        </div>
                    </div>

                    <div className='col-12'>
                        <div ><span className='fw-bold'>Subject:  </span><span contentEditable>Authorization Letter for Personnel and Vehicles Deputed at</span></div>
                        <div contentEditable>This is to formally inform you that the following persons from Global Info Services are authorized to work at the AFS Site. These employees and contractors will be responsible for the execution of assigned tasks. Below are the complete details of the staff members along with their Aadhar numbers, contact information, and vehicle details for your security records and site access:</div>
                    </div>

                    {teamList &&
                    <div className='col-12 mt-2'>
                            <table className='table table-bordered table-striped'  style={{pageBreakAfter:"avoid"}}>
                                <thead>
                                    <tr className='bg-warning'>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Position</th>
                                        <th>Aadhar</th>
                                        <th>Mobile</th>
                                        <th>Vehicle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {teamList.map((employee,i)=>
                                        <tr key={employee.teamId} >
                                            <th> {i+1}</th>
                                            <td><a href={'#team-'+employee.teamId}> {employee.employeeName} </a></td>
                                            <td>{ getMasterLabel("employee-designation", employee.employeeDesignation)}</td>
                                            <td>{employee.aadhar}</td>
                                            <td>{employee.phone}</td>
                                            <td>{employee.vehicle}</td>
                                            {editList &&
                                                <td>
                                                    <IconButton onClick={()=>remove(i)} ><Cancel/></IconButton>
                                                </td>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className='row'>
                                <div className='col-8'></div>
                                <div className='col-4 text-center'>
                                    <div><img  style={{maxWidth:"1in", height:"auto"}} src={companyList[selectedCompany].authSign}/></div>
                                </div>
                            </div>
                            <table></table>
                            <table className='table table-bordered table-striped'>
                                
                                    {teamList.map((employee,i)=>
                                        <tbody key={employee.teamId} id={"team-"+employee.teamId}>
                                            
                                            <tr className='text-center'>
                                                <th colSpan={ 2}>{employee.employeeName}</th>
                                            </tr>
                                            <tr key={employee.teamId}>
                                                <td className='text-center' colSpan={ employee.idProof2==null?2:1}>
                                                    <img style={{maxWidth:"4in"}} src={ employee.idProof1} />
                                                </td>
                                                {employee.idProof2 !== null &&
                                                    <td className='text-center'>
                                                        <img style={{maxWidth:"4in"}} src={ employee.idProof2} />
                                                    </td>
                                                }
                                            </tr>
                                        </tbody>
                                    )}
                                
                            </table>
                    </div>
                    }
                </div>
            </div>
        </AppLayout>
        

    )
}

export default ProjectTeamDetailsPage